import PropTypes from 'prop-types';

const FormatCell = ({ value }) => {
    return (
        <div className="font-GMedium text-sm uppercase -tracking-wider text-icoGray-500 dark:text-icoDarkMode-wolf">
            {value}
        </div>
    );
};

FormatCell.propTypes = {
    value: PropTypes.string
};

export default FormatCell;
